import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["enabled", "children"];
import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import Box from '../Box';
import { isFunction } from '../utils';
import { canUseDOM } from '../utils/environment';
var StickyWrapper = styled(Box).withConfig({
  displayName: "Sticky__StickyWrapper",
  componentId: "sc-om56ei-0"
})(["", ";"], function (_ref) {
  var enabled = _ref.enabled;
  return enabled && css(["position:sticky;top:-1px;padding-top:1px;"]);
});

var Sticky = function Sticky(_ref2) {
  var _ref2$enabled = _ref2.enabled,
      enabled = _ref2$enabled === void 0 ? true : _ref2$enabled,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded);

  var stickyRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPinned = _useState2[0],
      setPinned = _useState2[1];

  var previousY = 0;
  var observer = canUseDOM() ? new IntersectionObserver(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        e = _ref4[0];

    if (enabled) {
      var currentY = e.boundingClientRect.y;
      setPinned(currentY !== previousY && e.intersectionRatio < 1);
      previousY = currentY;
    }
  }, {
    threshold: [1]
  }) : null;
  useEffect(function () {
    var el = stickyRef.current;

    if (stickyRef.current && observer) {
      observer.observe(el);
    }

    return function () {
      if (observer) {
        observer.unobserve(el);
      }
    };
  }, [observer]);
  return /*#__PURE__*/React.createElement(StickyWrapper, _extends({
    enabled: enabled
  }, props, {
    ref: stickyRef
  }), isFunction(children) ? children({
    pinned: isPinned
  }) : /*#__PURE__*/React.cloneElement(children, {
    pinned: isPinned
  }));
};

export default Sticky;